import BrandsSubscriptionsStore from '../store/schema/BrandsSubscriptionsStore';
import getStore from '../store/store';
import { mutator } from 'satcheljs';
import { updateBrandsSubscriptions } from '../actions/internalActions';

export default mutator(updateBrandsSubscriptions, actionMessage => {
    const brandsSubscriptionsStore: BrandsSubscriptionsStore = getStore();
    brandsSubscriptionsStore.subscriptions = actionMessage.response.subscriptions;
    brandsSubscriptionsStore.unsubscribedSubscriptions =
        actionMessage.response.unsubscribedSubscriptions;
});
